import { render, staticRenderFns } from "./MasterColorTop.vue?vue&type=template&id=684a99dc&scoped=true&"
import script from "./MasterColorTop.vue?vue&type=script&lang=js&"
export * from "./MasterColorTop.vue?vue&type=script&lang=js&"
import style0 from "./MasterColorTop.vue?vue&type=style&index=0&id=684a99dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a99dc",
  null
  
)

export default component.exports